import { FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getAltreNotGroup = (form: FormGroup): FormGroup =>
    getGroup(form, formPaths.altreNotizie);

export const getAltreNotControl = (form: FormGroup, path: string) =>
    getControl(form, `${formPaths.altreNotizie}.${path}`);

export const altreNotCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath = formPaths.altreNotizie,
    suppCondition = true,
    errorStatus?: string
): void => checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition, errorStatus);
